import RandomQuotes from './components/RandomQuotes';
import './App.css';


function App() {
  return (
    <>
    <RandomQuotes />
    </>
  );
}

export default App;
